import blue from "@material-ui/core/colors/blue";
import green from "@material-ui/core/colors/green";
import pink from "@material-ui/core/colors/pink";
import esforco1 from "../../../images/esforco1.png";
import esforco2 from "../../../images/esforco2.png";
import esforco3 from "../../../images/esforco3.png";
import esforco4 from "../../../images/esforco4.png";

export const getColor = (treino) => {
  const number = 300;
  switch (treino.tipo) {
    case "Choque":
      return pink[number];
    case "Regenerativo":
      return green[number];
    case "Condicionante":
      return blue[number];
    default:
      return "#3788D8";
  }
};

export const getImage = (esforco) => {
  switch (esforco) {
    case 1:
      return esforco1;
    case 2:
      return esforco2;
    case 3:
      return esforco3;
    case 4:
      return esforco4;
    default:
      return null;
  }
};
